var _style, _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 786.47 248.94",
    style: {
      enableBackground: "new 0 0 786.47 248.94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#A80F1A;}\n\t.st2{fill:#04001F;}\n\t.st3{fill:#950808;}\n\t.st4{opacity:0.5;fill:url(#SVGID_3_);}\n\t.st5{opacity:0.4;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st6{opacity:0.61;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st7{opacity:0.61;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 786.47,
    height: 248.94
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M567.03,79.58c1.49,0.25,2.98,0.46,4.45,0.81c4.43,1.06,8.32,3.22,11.7,6.27c3,2.72,5.32,5.92,6.89,9.64 c2.59,6.17,2.93,12.42,0.7,18.82c-2.05,5.86-4.62,11.48-7.54,16.92c-2.48,4.61-5.12,9.14-7.82,13.65 c-2.41,4.05-4.97,7.99-7.48,11.96c-0.58,0.92-1.19,1.82-1.82,2.74c-0.74,1.08-2.33,1.07-3.05-0.02c-0.23-0.34-0.45-0.69-0.67-1.03 c-3.62-5.75-7.36-11.46-10.79-17.32c-3.15-5.39-6.05-10.96-8.9-16.5c-2.14-4.2-3.87-8.59-5.07-13.15 c-1.04-3.87-0.87-7.73,0.01-11.6c0.75-3.19,2.03-6.12,3.83-8.84c1.63-2.47,3.62-4.65,5.95-6.49c3.35-2.62,7.09-4.43,11.27-5.32 c1.24-0.24,2.5-0.42,3.75-0.6C563.98,79.55,565.49,79.57,567.03,79.58z M564.61,121.09c7.61-0.02,13.81-6.24,13.85-13.84 c0.01-7.68-6.25-13.97-13.91-13.93c-7.66,0.05-13.81,6.22-13.83,13.92C550.7,114.83,557,121.12,564.61,121.09z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.64,98.2l17.64,45.41c0.95,2.33,2.07,3.93,3.35,4.79s2.86,1.46,4.74,1.76v1.03H32.49v-1.03 c3.4-0.19,5.1-1.26,5.1-3.21c0-0.31-0.05-0.74-0.16-1.3c-0.11-0.56-0.25-1.15-0.43-1.78c-0.18-0.63-0.29-1.02-0.34-1.16 l-4.38-11.16H16.6l-3.74,10.73c-0.48,1.28-0.71,2.45-0.71,3.49c0,1.62,0.48,2.7,1.43,3.26c0.95,0.56,2.08,0.93,3.39,1.12v1.03 H1.2v-1.03c1.64-0.17,3.17-0.93,4.6-2.3c1.43-1.37,2.8-3.88,4.13-7.54l14.9-42.13H31.64z M17.81,128.07h13.08l-6.77-17.68 L17.81,128.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.24,113.24h-1.03c-1.38-3.64-3.68-6.59-6.9-8.86c-3.22-2.27-6.98-3.4-11.28-3.4 c-3.33,0-6.1,0.71-8.31,2.14s-3.93,3.32-5.15,5.69c-1.22,2.37-2.07,4.93-2.55,7.68c-0.48,2.76-0.71,5.67-0.71,8.73 c0,7.6,1.51,13.44,4.54,17.52c3.03,4.08,7.11,6.11,12.24,6.11c3.68,0,5.99-0.55,6.92-1.64s1.39-2.71,1.39-4.85v-6.06 c0-1.21-0.1-2.28-0.29-3.21c-0.19-0.93-0.68-1.78-1.48-2.55c-0.8-0.77-2-1.21-3.62-1.3v-1.11h21.89v1.11 c-3.21,0.43-4.81,2.39-4.81,5.88v12.8c-5.61,2.57-11.95,3.85-19.03,3.85c-2.85,0-5.44-0.2-7.75-0.59 c-2.32-0.39-4.38-0.94-6.18-1.64c-1.81-0.7-3.33-1.46-4.56-2.28c-1.24-0.82-2.4-1.74-3.49-2.76c-1.5-1.43-2.83-3.07-4.01-4.92 c-1.18-1.85-2.14-4.01-2.89-6.47c-0.75-2.46-1.12-5.16-1.12-8.11c0-3.97,0.71-7.59,2.12-10.87c1.41-3.28,3.42-6.12,6.01-8.54 c2.59-2.41,5.55-4.25,8.89-5.51c3.34-1.26,6.86-1.89,10.57-1.89c2.09,0,3.9,0.14,5.42,0.43c1.52,0.29,4.08,0.9,7.66,1.85 c1.14,0.38,2.38,0.57,3.71,0.57c1.4,0,2.33-0.93,2.78-2.78h1.03V113.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.65,98.7l0.43,11.76h-1.03c-0.48-1.97-1-3.6-1.59-4.88c-0.58-1.28-1.41-2.26-2.48-2.94 c-1.07-0.68-2.53-1.02-4.38-1.02h-10.59v22.06h8.45c2.52,0,4.35-0.56,5.51-1.68c1.15-1.12,1.82-2.77,2.01-4.95h1.03v15.4h-1.03 c-0.36-2.33-1.22-3.89-2.6-4.67c-1.38-0.78-3.02-1.18-4.92-1.18h-8.45v15.11c0,4.37,2.26,6.56,6.77,6.56H135 c2.16,0,3.93-0.29,5.29-0.86c1.37-0.57,2.5-1.55,3.39-2.94c0.89-1.39,1.69-3.36,2.41-5.9h1.03l-0.78,12.62h-39.57v-1.03 c2.76,0,4.54-0.62,5.35-1.87c0.81-1.25,1.21-2.88,1.21-4.9v-36.79c0-1.92-0.37-3.55-1.1-4.88c-0.74-1.33-2.44-2-5.1-2h-0.36V98.7 H144.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.07,98.7l32.04,33.83V108.5c0-3.16-0.64-5.32-1.92-6.47c-1.28-1.15-3.24-1.92-5.88-2.3V98.7h18.11v1.03 c-2,0.21-3.48,0.75-4.46,1.62c-0.97,0.87-1.6,1.88-1.89,3.05c-0.29,1.16-0.43,2.53-0.43,4.1v43.27h-1.32l-38.42-40.42v29.55 c0,2.47,0.53,4.58,1.59,6.33c1.06,1.75,3.01,2.73,5.86,2.94v1.03H149.6v-1.03c5.25-0.43,7.85-3.01,7.81-7.73v-34.75 c-0.14-0.09-0.33-0.26-0.57-0.5c-0.21-0.21-0.57-0.56-1.07-1.03c-0.5-0.48-0.95-0.9-1.35-1.28c-3.18-3.07-5.98-4.78-8.38-5.13 V98.7H165.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.73,98.7h36.68c1.69,0,3.09-0.21,4.21-0.64h1.03l0.29,12.33h-1c-0.52-3.61-1.41-5.91-2.66-6.9 c-1.25-0.99-2.77-1.48-4.58-1.48h-9.8v41.38c0,1.38,0.15,2.55,0.46,3.51c0.31,0.96,0.94,1.75,1.89,2.35 c0.95,0.61,2.34,0.91,4.17,0.91v1.03h-24.7v-1.03c2.73,0,4.5-0.62,5.31-1.85c0.81-1.24,1.21-2.88,1.21-4.92v-41.38h-9.8 c-1.66,0-3.02,0.53-4.06,1.59c-1.05,1.06-2.07,3.32-3.07,6.79h-1.1l0.29-12.33h1.03C208.64,98.48,210.04,98.7,211.73,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.01,98.7v1.03c-1.38,0.1-2.51,0.27-3.4,0.52c-0.89,0.25-1.63,0.82-2.23,1.71 c-0.59,0.89-0.81,2.22-0.64,3.97l2.89,35.25c0.21,2.47,0.56,4.3,1.05,5.47c0.49,1.18,1.09,1.97,1.82,2.37 c0.72,0.4,1.87,0.78,3.44,1.14v1.03h-24.1v-1.03c2.02-0.05,3.61-0.58,4.76-1.6c1.15-1.02,1.61-3.04,1.37-6.06l-2.57-33.44h-0.14 l-17.15,42.13h-1.25l-17.68-40.74h-0.14l-2.32,29.26c-0.24,2.88-0.04,5.08,0.61,6.61c0.64,1.53,1.49,2.53,2.55,2.99 c1.06,0.46,2.29,0.74,3.69,0.84v1.03h-17.82v-1.03c2.26-0.14,3.96-1.04,5.12-2.71c1.15-1.66,1.93-4.43,2.33-8.3l3.53-33.22 c-2.21-3.54-5.23-5.61-9.05-6.2V98.7h18.96l15.18,34.54L324.9,98.7H342.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345.66,124.79c0-3.56,0.61-6.97,1.84-10.23c1.22-3.26,3.02-6.11,5.4-8.57c2.38-2.46,5.26-4.37,8.64-5.74 c3.39-1.37,7.22-2.05,11.5-2.05c4.32,0,8.18,0.69,11.57,2.09c3.39,1.39,6.26,3.32,8.63,5.79c2.36,2.47,4.15,5.33,5.36,8.57 c1.21,3.24,1.82,6.7,1.82,10.35c0,3.64-0.59,7.06-1.76,10.27c-1.18,3.21-2.91,6.05-5.19,8.52s-5.15,4.42-8.61,5.85 c-3.46,1.43-7.37,2.14-11.75,2.14c-4.71,0-8.81-0.8-12.32-2.41c-3.51-1.6-6.37-3.72-8.59-6.36c-2.22-2.64-3.87-5.55-4.94-8.73 C346.19,131.09,345.66,127.93,345.66,124.79z M358.14,124.11c0,3.56,0.27,7.08,0.8,10.53c0.54,3.46,1.92,6.69,4.15,9.7 c2.23,3.01,5.6,4.51,10.09,4.51c6.3,0,10.33-2.54,12.1-7.61c1.77-5.07,2.66-10.25,2.66-15.52c0-4.11-0.36-7.96-1.07-11.55 c-0.71-3.59-2.17-6.66-4.37-9.21c-2.2-2.55-5.31-3.83-9.32-3.83c-4.52,0-7.88,1.46-10.11,4.37c-2.22,2.91-3.6,6.01-4.13,9.29 C358.4,118.05,358.14,121.17,358.14,124.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.56,98.7l32.04,33.83V108.5c0-3.16-0.64-5.32-1.92-6.47c-1.28-1.15-3.24-1.92-5.88-2.3V98.7h18.11v1.03 c-2,0.21-3.48,0.75-4.46,1.62c-0.97,0.87-1.6,1.88-1.89,3.05c-0.29,1.16-0.43,2.53-0.43,4.1v43.27h-1.32l-38.42-40.42v29.55 c0,2.47,0.53,4.58,1.59,6.33c1.06,1.75,3.01,2.73,5.86,2.94v1.03h-18.75v-1.03c5.25-0.43,7.85-3.01,7.81-7.73v-34.75 c-0.14-0.09-0.33-0.26-0.57-0.5c-0.21-0.21-0.57-0.56-1.07-1.03c-0.5-0.48-0.95-0.9-1.35-1.28c-3.18-3.07-5.98-4.78-8.38-5.13 V98.7H420.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M462.13,99.66V98.7h24.67v1.03c-2.73,0-4.5,0.62-5.29,1.87c-0.8,1.25-1.19,2.89-1.19,4.94v36.86 c0,1.17,0.11,2.21,0.32,3.14s0.78,1.76,1.69,2.51c0.91,0.75,2.31,1.12,4.19,1.12h0.29v1.03h-24.67v-1.03 c2.71,0,4.47-0.62,5.28-1.85c0.81-1.24,1.21-2.88,1.21-4.92v-36.86c0-2.42-0.53-4.18-1.59-5.26 C465.98,100.2,464.34,99.66,462.13,99.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492.05,98.7h36.68c1.69,0,3.09-0.21,4.21-0.64h1.03l0.29,12.33h-1c-0.52-3.61-1.41-5.91-2.66-6.9 c-1.25-0.99-2.78-1.48-4.58-1.48h-9.8v41.38c0,1.38,0.15,2.55,0.46,3.51c0.31,0.96,0.94,1.75,1.89,2.35 c0.95,0.61,2.34,0.91,4.17,0.91v1.03h-24.7v-1.03c2.73,0,4.5-0.62,5.31-1.85c0.81-1.24,1.21-2.88,1.21-4.92v-41.38h-9.8 c-1.66,0-3.02,0.53-4.06,1.59c-1.05,1.06-2.07,3.32-3.07,6.79h-1.1l0.29-12.33h1.03C488.96,98.48,490.36,98.7,492.05,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M613.26,126.61h-1.68v16.79c0,2,0.3,3.49,0.89,4.47c0.59,0.99,1.32,1.62,2.17,1.89s2,0.43,3.42,0.48v0.96 h-24.67v-1.03c2.76,0,4.53-0.62,5.31-1.85c0.78-1.24,1.18-2.88,1.18-4.92v-36.79c0-2.52-0.51-4.3-1.53-5.33 c-1.02-1.03-2.67-1.55-4.95-1.55V98.7h27.23c3.59,0,6.74,0.56,9.45,1.68c2.71,1.12,4.78,2.7,6.2,4.74 c1.43,2.04,2.14,4.38,2.14,7.02c0,2.14-0.45,4.04-1.35,5.7c-0.9,1.66-2.12,3.03-3.65,4.1c-1.53,1.07-3.24,1.89-5.12,2.46 c2.45,1.54,4.82,4.28,7.13,8.2l6.27,10.66c1.07,1.83,2.05,3.25,2.96,4.26c0.9,1.01,1.7,1.68,2.39,2 c0.69,0.32,1.44,0.54,2.25,0.66v1.03h-16.93c-1.64-2.97-2.9-5.33-3.78-7.09c-2.8-5.49-4.85-9.3-6.13-11.44s-2.61-3.68-3.97-4.63 S615.37,126.61,613.26,126.61z M614.44,101.62h-2.85v22.06h2.39c4.09,0,7.16-0.98,9.23-2.94c2.07-1.96,3.1-4.78,3.1-8.47 c0-2.28-0.45-4.21-1.34-5.79c-0.89-1.58-2.22-2.79-3.99-3.62C619.21,102.04,617.03,101.62,614.44,101.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M646.7,99.66V98.7h24.67v1.03c-2.73,0-4.5,0.62-5.29,1.87c-0.8,1.25-1.19,2.89-1.19,4.94v36.86 c0,1.17,0.11,2.21,0.32,3.14s0.78,1.76,1.69,2.51c0.91,0.75,2.31,1.12,4.19,1.12h0.29v1.03H646.7v-1.03 c2.71,0,4.47-0.62,5.28-1.85c0.81-1.24,1.21-2.88,1.21-4.92v-36.86c0-2.42-0.53-4.18-1.59-5.26 C650.54,100.2,648.91,99.66,646.7,99.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M688.01,98.7l32.04,33.83V108.5c0-3.16-0.64-5.32-1.92-6.47c-1.28-1.15-3.24-1.92-5.88-2.3V98.7h18.11v1.03 c-2,0.21-3.48,0.75-4.46,1.62c-0.97,0.87-1.6,1.88-1.89,3.05c-0.29,1.16-0.43,2.53-0.43,4.1v43.27h-1.32l-38.42-40.42v29.55 c0,2.47,0.53,4.58,1.59,6.33c1.06,1.75,3.01,2.73,5.86,2.94v1.03h-18.75v-1.03c5.25-0.43,7.85-3.01,7.81-7.73v-34.75 c-0.14-0.09-0.33-0.26-0.57-0.5c-0.21-0.21-0.57-0.56-1.07-1.03c-0.5-0.48-0.95-0.9-1.35-1.28c-3.18-3.07-5.98-4.78-8.38-5.13 V98.7H688.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M777.77,113.24h-1.03c-1.38-3.64-3.68-6.59-6.9-8.86c-3.22-2.27-6.98-3.4-11.28-3.4 c-3.33,0-6.1,0.71-8.31,2.14s-3.93,3.32-5.15,5.69c-1.22,2.37-2.07,4.93-2.55,7.68c-0.48,2.76-0.71,5.67-0.71,8.73 c0,7.6,1.51,13.44,4.54,17.52c3.03,4.08,7.11,6.11,12.24,6.11c3.68,0,5.99-0.55,6.92-1.64c0.93-1.09,1.39-2.71,1.39-4.85v-6.06 c0-1.21-0.1-2.28-0.29-3.21c-0.19-0.93-0.68-1.78-1.48-2.55c-0.8-0.77-2-1.21-3.62-1.3v-1.11h21.88v1.11 c-3.21,0.43-4.81,2.39-4.81,5.88v12.8c-5.61,2.57-11.95,3.85-19.03,3.85c-2.85,0-5.44-0.2-7.75-0.59 c-2.32-0.39-4.38-0.94-6.18-1.64s-3.33-1.46-4.56-2.28c-1.24-0.82-2.4-1.74-3.49-2.76c-1.5-1.43-2.83-3.07-4.01-4.92 c-1.18-1.85-2.14-4.01-2.89-6.47c-0.75-2.46-1.12-5.16-1.12-8.11c0-3.97,0.71-7.59,2.12-10.87c1.41-3.28,3.42-6.12,6.01-8.54 c2.59-2.41,5.55-4.25,8.89-5.51c3.34-1.26,6.86-1.89,10.57-1.89c2.09,0,3.9,0.14,5.42,0.43c1.52,0.29,4.08,0.9,7.66,1.85 c1.14,0.38,2.38,0.57,3.71,0.57c1.4,0,2.33-0.93,2.78-2.78h1.03V113.24z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325.4,23.25c0,0-65.03-10.53-130.47,4.51c-10.49,2.41-24.48,6.4-37.09,16.92 c-18.49,15.43-22.97,35.68-24.3,45.13c-12.47-24.65-9.61-39.6-5.12-48.51c25.06-49.64,169.14-46.49,269.9-16.92 c60.71,17.81,104.81,44.96,131.59,64.19C483.55,66.64,410.6,37.05,325.4,23.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.04,227.13c0,0,65.33,10.69,131.32-3.11c10.57-2.21,24.69-5.9,37.47-15.85 c18.74-14.59,23.43-33.93,24.85-42.97c12.33,23.71,9.32,38,4.72,46.48c-25.65,47.28-170.6,42.92-271.71,13.69 c-60.92-17.62-105.06-44.01-131.83-62.66C227.3,184.12,300.45,213.13,386.04,227.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.077,
    y1: 84.7458,
    x2: 543.3294,
    y2: 148.3946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#950808",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    style: {
      stopColor: "#960A0A",
      stopOpacity: 0.875
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    style: {
      stopColor: "#991111",
      stopOpacity: 0.902
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    style: {
      stopColor: "#9E1C1C",
      stopOpacity: 0.9213
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6843,
    style: {
      stopColor: "#A52D2D",
      stopOpacity: 0.9369
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    style: {
      stopColor: "#AF4343",
      stopOpacity: 0.9502
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8102,
    style: {
      stopColor: "#BA5F5F",
      stopOpacity: 0.962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    style: {
      stopColor: "#C87F7F",
      stopOpacity: 0.9727
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    style: {
      stopColor: "#D8A5A5",
      stopOpacity: 0.9825
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    style: {
      stopColor: "#EACECE",
      stopOpacity: 0.9913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    style: {
      stopColor: "#FEFCFC",
      stopOpacity: 0.9994
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M567.91,80.07c1.34,0.25,2.67,0.46,3.98,0.8c3.97,1.06,7.45,3.2,10.48,6.22c2.69,2.7,4.76,5.88,6.17,9.57 c2.32,6.12,2.62,12.33,0.63,18.68c-1.84,5.81-4.13,11.39-6.75,16.79c-2.22,4.58-4.59,9.07-7,13.55c-2.16,4.02-4.45,7.94-6.7,11.87 c-0.52,0.91-1.07,1.81-1.63,2.72c-0.66,1.07-2.09,1.06-2.73-0.02c-0.2-0.34-0.4-0.68-0.6-1.02c-3.24-5.71-6.59-11.38-9.66-17.19 c-2.82-5.35-5.41-10.88-7.97-16.38c-1.92-4.17-3.46-8.53-4.54-13.06c-0.93-3.84-0.78-7.67,0.01-11.51 c0.67-3.16,1.82-6.07,3.43-8.77c1.46-2.46,3.24-4.61,5.33-6.44c3-2.6,6.35-4.39,10.09-5.28c1.11-0.24,2.24-0.42,3.36-0.6 C565.18,80.04,566.53,80.05,567.91,80.07z M565.74,121.27c6.81-0.02,12.37-6.19,12.4-13.73c0.01-7.62-5.6-13.87-12.45-13.83 c-6.86,0.05-12.37,6.17-12.39,13.82C553.29,115.06,558.93,121.3,565.74,121.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.0774,
    y1: 171.2171,
    x2: 564.0774,
    y2: 128.4251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M590.1,96.52c-1.62-3.72-3.97-6.92-7.03-9.64c-3.46-3.03-7.42-5.2-11.95-6.28c-1.67-0.38-3.41-0.6-5.12-0.9 h-3.81c-1.38,0.2-2.77,0.38-4.13,0.65c-4.28,0.89-8.09,2.7-11.51,5.32c-2.38,1.83-4.41,4-6.07,6.47 c-1.84,2.74-3.15,5.69-3.91,8.85c-0.91,3.88-1.07,7.73-0.02,11.61c1.24,4.54,3,8.92,5.18,13.14c2.92,5.54,5.88,11.1,9.1,16.49 c3.51,5.85,7.32,11.58,11.02,17.33c0.67,1.08,1.44,2.14,2.23,3.29c1.19-1.71,2.33-3.32,3.41-4.98c2.59-3.97,5.19-7.91,7.64-11.96 c2.75-4.51,5.44-9.05,7.98-13.65c2.98-5.44,5.6-11.06,7.7-16.9C593.08,108.95,592.76,102.68,590.1,96.52z M564.12,121.3 c-7.77,0.01-21.78-15.43-14.17-13.87c19.56,4.02,13.3-9.66,14.1-13.9c1.43-7.55,14.22,6.25,14.2,13.93 C578.23,115.06,571.89,121.28,564.12,121.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2023.6392,
    y1: 436.9322,
    x2: 2023.6392,
    y2: 270.0231,
    gradientTransform: "matrix(0.5003 0.3424 -0.8737 1.2767 -441.8131 -975.4552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M585.9,20.77c-2.04-4.17-35.58-1.54-37.63-5.53C537.01-5.87,348.23-5.65,326.88-5.56 c-67.65,0.29-85.97,107.37-94.06,17.61c-31.9,25.36-75.99,16.86-76.78,98.68l-37.34-38.88C123.06-8.1,237.05-29.46,290.48-21.89 C372.36-10.29,529.96-117.5,585.9,20.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 980.2305,
    y1: -122.5925,
    x2: 980.2305,
    y2: -289.5016,
    gradientTransform: "matrix(-0.2156 -0.7062 2.1003 -1.0359 1215.9177 645.7377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.17,236.78c-5.82-4.72-12.76-8.86-20.56-12.57c0.1-0.87,0.2-1.74,0.3-2.61c0.82,0.84,1.64,1.68,2.46,2.51 c3.03,3.05,7.26,1.29,8.81-3.18c1.78-5.12,4.77-8.8,8.44-11.48c6.84,0.11,14.02-1.47,20.56-2.97c5.2-1.19,10.5-3.18,15.72-3.75 c4.27-0.47,8.51-0.52,12.78-1.29c2.55-0.45,5.03-1.07,7.44-1.9c9.76-1.87,19.54-5.9,29.3-5.05c1.84,0.16,3.18-0.66,4.02-1.94 c3.72,5.6,9.34,10.6,16.11,8.4c1.48,0.72,2.94,0.56,4.19-0.11c-3.81,7.23-9.45,16.56-17.22,28.46 c57.14-12.09,96.07,23.91,172.15-74.68l3.83,68.84C512.35,317.73,371.86,277.1,322.17,236.78z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoams);
export default __webpack_public_path__ + "static/media/LOGOAMS.b2735e7cea7d6a3b1635f55c9a35b82a.svg";
export { ForwardRef as ReactComponent };